module.exports = __webpack_public_path__ + "img/4.532cb239.png";